/**
 * Created by USER on 18/6/27.
 */
import React, { Component } from 'react';

export default class Loading extends Component {
  render() {
    return (
      <div className="loading">
        页面加载中， 请稍后。。。
      </div>
    );
  }
}
